module.exports = __webpack_public_path__ + "img/story6.b18b61f5.png";